import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const StatsPage = lazy(() =>
  import("@/admin/pages/StatsPage").then((m) => ({ default: m.StatsPage })),
);

export const Route = createFileRoute("/admin/stats")({
  component: () => (
    <Suspense fallback={null}>
      <StatsPage />
    </Suspense>
  ),
});
